{
  "active": "Active",
  "pinned": "Pinned",
  "read": "Read",
  "inactive": "Inactive",
  "empty": "No agent activity yet.",
  "loadMore": "Show more",
  "openProject": "Open a project to view agents.",
  "loadError": "Failed to load agents.",
  "pin": "Pin agent",
  "unpin": "Unpin agent",
  "unpinConfirm": "Unpin this agent?",
  "working": "Agent is working",
  "surfaces": {
    "shots_assistant": "Storyboard",
    "script_assistant": "Script",
    "scene3d_assistant": "3D scenes",
    "skills_discussion_assistant": "Skills discussion",
    "skills_editor_assistant": "Skills editor",
    "projects_assistant": "Projects"
  },
  "preview": {
    "agent": "Agent",
    "you": "You",
    "empty": "no messages"
  }
}
